import {cn} from "@/utils/cn.ts";
import styles from "@/pages/Refund/RefundPage.module.scss";
import {useState} from "react";
import { API_URL } from "@/config.tsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";

/**
 * Блок с возвратом товаров ненадлежащего качества
 * @constructor
 */
export const NotQualityRefund = () => {
    const [defectBlank, setDefectBlank] = useState<File | null>(null);
    const [defectDetail, setDefectDetail] = useState<File | null>(null);
    const [defectOrder, setDefectOrder] = useState<File | null>(null);
    const [defectAct, setDefectAct] = useState<File | null>(null);
    const [disabled, setDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const setters = {
        defectBlank: setDefectBlank,
        defectDetail: setDefectDetail,
        defectOrder: setDefectOrder,
        defectAct: setDefectAct,
    };

    /** Добавление файлов */
    const addDefectFile = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
        const file = event.target.files?.[0] ?? null;

        if (file) {
            setters[type as keyof typeof setters](file);
        }

        if (type === 'defectBlank') {
            setDisabled(false);
        }
    };

    /** Отправка запроса на возврат ненадлежащего качества */
    const defectOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('defectBlank', defectBlank ?? '');
        formData.append('defectDetail', defectDetail ?? '');
        formData.append('defectOrder', defectOrder ?? '');
        formData.append('defectAct', defectAct ?? '');

        newRefoundNotQualityRequest(formData);
    };

    /** Отправка заявки на возврат */
    const newRefoundNotQualityRequest = (formData: FormData) => {
        setIsLoading(true);
        setDisabled(true);
        axios.post(`${API_URL}/refund_not_quality`, formData, {withCredentials: true})
            .then(response => response.data)
            .then(data => {
                if (data?.success) {
                    setDefectBlank(null);
                    setDefectDetail(null);
                    setDefectOrder(null);
                    setDefectAct(null);
                    alert("Запрос успешно отправлен!");
                    navigate('/profile/refund_requests');
                }
            })
            .catch(error => {
                console.error(error);
                setDisabled(false);
            })
            .finally(() => setIsLoading(false));
    };


    return (
        <div>
            <h4>Возврат автозапчастей, ненадлежащего качества:</h4>
            <ul>
                <li> возможен при обнаружении недостатков в течение 14 дней после его получения (для заказов, полученных
                    через транспортную компанию, необходим подтверждающий документ).
                </li>
                <li> во время эксплуатации в течении гарантийного срока (если он установлен), но не позднее, чем через 2
                    года после покупки. При условии, что автозапчасть устанавливалась в Автосервисе и есть заказнаряд.
                </li>
            </ul>
            Скачайте <a href="assets/pretension_blank.pdf" className="primary-color" target="_blank">бланк претензии</a>.
            Опишите всю ситуацию. Далее заполните, пожалуйста, все поля и мы ответим вам в течении 1-2 рабочих дней.
            <form method="post"
                  className={cn("refund-form", styles.form)}
                  id="defectRefundForm"
                  encType="multipart/form-data"
                  onSubmit={defectOnSubmit}>
                <div className="defect-refund-form-row">
                    <div className="defect-refund-detail-image-block-row">
                        <div className="defect-refund-input-file-row" id="defectBlank">
                            <label className="defect-refund-input-file">
                                <input type="file"
                                       name="blankImage"
                                       id="blankImage"
                                       onChange={(e) => addDefectFile(e, 'defectBlank')}/>
                                Бланк претензии
                            </label>
                            <div className="defect-refund-input-file-list"></div>
                        </div>
                    </div>
                    <div className="defect-refund-detail-image-block-row">
                        <div className="defect-refund-input-file-row" id="defectDetail">
                            <label className="defect-refund-input-file">
                                <input type="file"
                                       name="defectDetailImage"
                                       id="defectDetailImage"
                                       accept="image/*"
                                       onChange={(e) => addDefectFile(e, 'defectDetail')}/>
                                Фото детали и маркировки
                            </label>
                            <div className="defect-refund-input-file-list"></div>
                        </div>
                    </div>
                    <div className="defect-refund-detail-image-block-row">
                        <div className="defect-refund-input-file-row" id="defectOrder">
                            <label className="defect-refund-input-file">
                                <input type="file"
                                       name="orderImage"
                                       id="orderImage"
                                       accept="image/*"
                                       onChange={(e) => addDefectFile(e, 'defectOrder')}/>
                                Копия заказ-наряда с печатью автосервиса
                            </label>
                            <div className="defect-refund-input-file-list"></div>
                        </div>
                    </div>
                    <div className="defect-refund-detail-image-block-row">
                        <div className="defect-refund-input-file-row" id="defectAct">
                            <label className="defect-refund-input-file">
                                <input type="file"
                                       name="actImage"
                                       id="actImage"
                                       accept="image/*"
                                       onChange={(e) => addDefectFile(e, 'defectAct')}/>
                                Копия акта дефектовки с печатью автосервиса
                            </label>
                            <div className="defect-refund-input-file-list"></div>
                        </div>
                    </div>
                </div>
                <div className="defect-refund-form-row">
                    <div className="defect-refund-detail-action-block">
                        <div className="defect-refund-detail-action-block-row"></div>
                        <button className={cn("defect-refund-input-button", styles.submitBtn, disabled && styles.submitBtn__disabled)}
                                id="sendDefectFormButton"
                                type="submit"
                                disabled={disabled}>
                            {!isLoading ? 'Отправить' : 'Отправка...'}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};
